export default function fitNodesOnScreen(networkRef) {
  if (networkRef.current) {
    networkRef.current.fit({
      animation: {
        duration: 2000,
        easingFunction: 'easeInOutQuad'
      }
    });
  }
};